import { lazyWithPreload } from '../../navigation';

export const TranslationsScreen = lazyWithPreload(() =>
    import('./TranslationsScreen').then((m) => ({ default: m.TranslationsScreen }))
);
